/** Canonical production hosts (one Netlify site, two domains). */
export const APP_ORIGIN = 'https://app.momotrading.app';
export const MARKETING_ORIGIN = 'https://momotrading.app';
export const LEGACY_NETLIFY_ORIGIN = 'https://momotrading.netlify.app';
